import template from "./individual-text-output-preview.html";
import {individualTextOutputPreviewController} from "./individual-text-output-preview.controller";
import "./individual-text-output-preview.scss";

/**
 * Draws the Individual Text fields over a transcluded <html-preview> of the print layout.
 * Text positions are px of the print canvas; with `editable` texts can be dragged.
 */
export const individualTextOutputPreviewComponent = {
    template,
    controller: individualTextOutputPreviewController,
    controllerAs: "textPreview",
    transclude: true,
    bindings: {
        settings: "<",
        canvasWidth: "<",
        canvasHeight: "<",
        index: "<",
        editable: "<"
    }
};



// WEBPACK FOOTER //
// ./sources/components/common/individual-text-output-preview/individual-text-output-preview.component.js